import HomePage from '@/views/HomePage.vue';
import PresupuestosPage from '@/views/PresupuestosPage.vue';
import ConsultasPage from '@/views/ConsultasPage.vue';
import ProyectosPage from '@/views/ProyectosPage.vue';
import CatalogoPage from '@/views/CatalogoPage.vue';
import DocumentosPage from '@/views/DocumentosPage.vue';
import TerminosPage from '@/views/TerminosPage.vue';
import PrivacidadPage from '@/views/PrivacidadPage.vue';
import CookiesPage from '@/views/CookiesPage.vue';
import AvisoLegalPage from '@/views/AvisoLegalPage.vue';

export const routes = [
  { path: '/', name: 'Home', component: HomePage },
  { path: '/presupuestos', name: 'Presupuestos', component: PresupuestosPage },
  { path: '/consultas', name: 'Consultas', component: ConsultasPage },
  { path: '/proyectos', name: 'Proyectos', component: ProyectosPage },
  { path: '/catalogo', name: 'Catalogo', component: CatalogoPage },
  { path: '/documentos', name: 'Documentos', component: DocumentosPage },
  { path: '/terminos', name: 'Terminos', component: TerminosPage },
  { path: '/privacidad', name: 'Privacidad', component: PrivacidadPage },
  { path: '/cookies', name: 'Cookies', component: CookiesPage },
  { path: '/aviso-legal', name: 'AvisoLegal', component: AvisoLegalPage },
  { path: '/index.html', redirect: '/' },
  { path: '/presupuestos.html', redirect: '/presupuestos' },
  { path: '/consultas.html', redirect: '/consultas' },
  { path: '/proyectos.html', redirect: '/proyectos' },
  { path: '/catalogo.html', redirect: '/catalogo' },
  { path: '/terminos.html', redirect: '/terminos' },
  { path: '/privacidad.html', redirect: '/privacidad' },
  { path: '/cookies.html', redirect: '/cookies' },
  { path: '/aviso-legal.html', redirect: '/aviso-legal' },
  { path: '/:pathMatch(.*)*', redirect: '/' },
];
